/* eslint-disable no-prototype-builtins */
/* eslint-disable react/no-unescaped-entities */
import React from 'react'
// mui
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'
import InputAdornment from '@mui/material/InputAdornment'
import { NumericFormatCustom } from './formatting'

import { handleChange } from './globalHelpers'
import { positionChangeWidthSm } from './variableDefaults'


// Login/Register process TextFields (username, email, password, passwordConfirmation) in inProcessLoginRegister.js
export const loginTextField = (name, label, value, variant, required, fullWidth, autoFocus, autoComplete, form, setForm, setErrors, changeHandler ) => {
  return (
    <TextField
      required={required}
      fullWidth={fullWidth}
      label={label}
      variant={variant}
      name={name}
      type={name.includes('password') || name.includes('Password') || name.includes('security') || name.includes('Security') ? 'password' : ''}
      autoFocus={autoFocus}
      value={value} 
      onChange={(e) => changeHandler(e, setErrors, setForm, form)}
      inputProps={{ 
        style: { textTransform: name.includes('password') ? 'none' : 'none' }, 
        autoComplete: 'new-password',
        form: {
          autoComplete: 'off',
        },
      }}
      sx={{
        backgroundColor: 'white',
      }}
    />
  )
}

// Textfield for inputting the recipient email address in ResetPassword.js
export const emailTextField = (name, value, placeholder, variant, clickHandler, state, setState, width) => {
  return (
    <TextField 
      variant={variant}
      name={name}
      maxLength={150}
      aria-label={name}
      placeholder={placeholder}
      autoComplete='off'
      value={value}
      onChange={(e) => clickHandler(e, state, setState)}
      color="primary"
      sx={{ 
        // backgroundColor: 'yellow',
        // width: width >= 440 ? 'calc(100% - 120px)' : '95%',
        width: '100%',
        // maxWidth: '325px', 
        // ml: '45px', 
        mt: 1,
      }}
    />
  )
}

// Textfield for searching name and email address in user dashboard
export const searchTextField = (name, value, placeholder, variant, state, setState, clickHandler, size, width, disabled) => {
  
  return (
    <TextField 
      variant={variant}
      name={name}
      maxLength={150}
      aria-label={name}
      placeholder={placeholder}
      disabled={disabled}
      autoComplete='off'
      size={size}
      value={value}
      onChange={(e) => clickHandler(e, state, setState)}
      color="primary"
      sx={{ 
        // backgroundColor: 'yellow',
        // width: width >= 440 ? 'calc(100% - 120px)' : '95%',
        width: '100%',
        // maxWidth: '325px', 
        // ml: '45px', 
        mt: 1,
      }}
    />
  )
}



// Textfield for inputting the security code in Security.js during the unwrap process
export const securityCodeTextField = (name, label, disabled, autoComplete, autoFocus, changeHandler) => {
  return (
    <TextField
      margin="normal"
      disabled={disabled}
      required
      fullWidth
      id={name}
      label={label}
      name={name}
      autoComplete={autoComplete}
      autoFocus={autoFocus}
      onChange={(e) => changeHandler(e.target.value)}
    />
  )
}

export const onlyNumbersItemTextField = (name, label, value, placeholder, focused, changeHandler, setForm, form, itemIndex ) => {
  return (
    <TextField
      focused={ focused }
      label={label}
      type={'number'}
      autoComplete='off'
      variant='outlined'
      placeholder={placeholder}
      name={name}
      value={value}
      minRows={1}
      maxRows={1}
      inputProps={{ maxLength: 75 }}
      size={'small'}
      onChange={(e) => changeHandler(e, setForm, form, itemIndex)}
      sx={{ 
        width: '90%', 
        textOverflow: 'ellipsis', 
        '.MuiInputBase-input': { 
          fontSize: '1rem', 
        }, 
      }}
    />
  )
}

// Vital Info Textfield (Variable max characters; error handling)
export const vitalInfoTextField = (name, label, value, variant, required, fullWidth, autoFocus, disabled, form, setForm, setErrors, changeHandler, maxChars = 150, marginTop = 0, marginBottom = 0, index = -1 ) => {
  return (
    <TextField
      required={required}
      label={label}
      variant={variant}
      name={name}
      disabled={disabled}
      maxLength={maxChars}
      autoFocus={autoFocus}
      fullWidth={fullWidth}
      value={value} 
      onChange={(e) => changeHandler(e, setErrors, setForm, form, index)}
      InputProps={{
        endAdornment: 
          <InputAdornment position="start">
            {value.length}/{maxChars}
          </InputAdornment>,
      }}
      sx={{
        mt: marginTop, mb: marginBottom,
        backgroundColor: 'white',
      }}
    />
  )
}

// Mission Textfield, appears in the Mission.js file, for writing a longer mission statement during the onboarding
export const descriptionTextField = (name, value, index, label, rows, maxChars, placeholder, focused, changeHandler, setErrors, setForm, form, marginTop) => {
  const upperCaseName = name.charAt(0).toUpperCase() + name.slice(1)

  return (
    <TextField
      focused={ focused }
      label={`${label}`}
      type= 'text'
      autoComplete='off'
      variant='outlined'
      placeholder={placeholder}
      name={name}
      value={value}
      multiline
      rows={rows}
      maxLength={maxChars}
      onChange={(e) => changeHandler(e, setErrors, setForm, form, index)}
      InputProps={{
        endAdornment: 
          <Box
            sx={{
              position: 'relative',
            }}
          >
            <InputAdornment position="start"
              sx={{
                position: 'absolute', top: rows === 2 ? 20 : rows === 3 ? 30 : 50, right: 0,
                // mt: 12,
                // display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'flex-end',
              }}
            >
              {value.length}/{maxChars}
            </InputAdornment>
          </Box>,
      }}
      sx={{ 
        mt: marginTop,
        // pb: 3,
        backgroundColor: 'white',
        width: '100%', 
        textOverflow: 'ellipsis', 
        '.MuiInputBase-input': { 
          fontSize: '1rem', 
        }, 
        '& .MuiOutlinedInput-input': {
          // backgroundColor: "#F5F5F5 !important",
          // borderWidth: 0,
          // outline: "none",
          // borderColor: "white !important",
          marginBottom: 2, // <-- added zero padding instruction
        },
      }}
    />
  )
}

// Mission Textfield, appears in the Mission.js file, for writing a longer mission statement during the onboarding
export const descriptionTextFieldNoIndexOrChangeHandler = (name, value, label, rows, maxChars, placeholder, focused, setForm, form, marginTop) => {
  const upperCaseName = name.charAt(0).toUpperCase() + name.slice(1)

  return (
    <TextField
      focused={ focused }
      label={`${label}`}
      type= 'text'
      autoComplete='off'
      variant='outlined'
      placeholder={placeholder}
      name={name}
      value={value}
      multiline
      rows={rows}
      maxLength={maxChars}
      onChange={(e) => typeof form === 'object' ? setForm({ ...form, [name]: e.target.value !== ' ' ? e.target.value : '' }) : typeof form === 'string' ? setForm(e.target.value !== ' ' ? e.target.value : '' ) : console.log('incorrect data type')}
      InputProps={{
        endAdornment: 
          <Box
            sx={{
              position: 'relative',
            }}
          >
            <InputAdornment position="start"
              sx={{
                position: 'absolute', top: rows === 2 ? 20 : rows === 3 ? 30 : 50, right: 0,
                // mt: 12,
                // display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'flex-end',
              }}
            >
              {value.length}/{maxChars}
            </InputAdornment>
          </Box>,
      }}
      sx={{ 
        mt: marginTop,
        // pb: 3,
        backgroundColor: 'white',
        width: '100%', 
        textOverflow: 'ellipsis', 
        '.MuiInputBase-input': { 
          fontSize: '1rem', 
        }, 
        '& .MuiOutlinedInput-input': {
          // backgroundColor: "#F5F5F5 !important",
          // borderWidth: 0,
          // outline: "none",
          // borderColor: "white !important",
          marginBottom: 2, // <-- added zero padding instruction
        },
      }}
    />
  )
}

// Textfield for inputting name and email address when adding a new friend reviewer
export const newFriendReviewerTextField = (name, value, placeholder, variant, state, setState, setErrors, size, width, index) => {
  
  const handleNewFriendReviewerChange = (e, setErrors, setFormData, formData, index) => {
    const { name, value } = e.target
    // console.log('name ->', name)
    // console.log('value ->', value)

    const friends = [ ...formData ]
    friends[index] = { ...formData[index], [name]: (name === 'email') ? value.toLowerCase() : value }
  
    setErrors(false)
    setFormData([ ...friends ])
    
  }

  return (
    <TextField 
      variant={variant}
      name={name}
      maxLength={150}
      label={placeholder}
      // focused={true}
      aria-label={name}
      placeholder={placeholder}
      autoComplete='off'
      // size={size}
      value={value}
      onChange={(e) => handleNewFriendReviewerChange(e, setErrors, setState, state, index)}
      color="primary"
      sx={{ 
        backgroundColor: 'white',
        // width: width >= 440 ? 'calc(100% - 120px)' : '95%',
        // width: width < positionChangeWidthSm ? '90%' : 'calc(48% - 40px)', 
        width: width < positionChangeWidthSm ? '90%' : state.length <= 1 ? '48%' : '45%', 
        maxWidth: state.length <= 1 ? '290px' : '260px',
        // maxWidth: '325px', 
        // ml: '45px', 
        mt: 1,
      }}
    />
  )
}

export const reviewRateTextField = (name, label, type, value, placeholder, disabled, focused, changeHandler, setRateAndVisibilityObj, rateAndVisibilityObj, setErrors ) => {
  // console.log('disabled ->', disabled)
  // console.log('focused ->', focused)
  
  return (
    <TextField
      focused={focused}
      disabled={disabled}
      label={label}
      type= {type}
      autoComplete='off'
      variant='standard'
      placeholder={placeholder}
      name={name}
      value={value}
      minRows={1}
      maxRows={1}
      inputProps={{ 
        maxLength: 4,
      }}
      InputProps={{
        startAdornment: <InputAdornment position="start">$</InputAdornment>,
        inputComponent: NumericFormatCustom,
        inputMode: 'numeric', 
        pattern: '[0-9]*',
      }}
      size={'small'}
      onChange={(e) => changeHandler(e, setErrors, setRateAndVisibilityObj, rateAndVisibilityObj)}
      sx={{ 
        width: '75px', 
        textOverflow: 'ellipsis', 
        '.MuiInputBase-input': { 
          fontSize: '1rem', 
        }, 
      }}
    />
  )
}